





















































































import Vue from "vue";
import { mapActions } from "vuex";
import configuredAxios from "@/modules/configured-axios";
import configManager from "@/modules/config-manager";
import AddFrameShapeDialogVue from "@/components/AddFrameShapeDialog.vue";
import FrameShapeInterface from "@/interfaces/db/FrameShapeInterface";
import EditFrameShapeDialogVue from "@/components/EditFrameShapeDialog.vue";

export default Vue.extend({
  components: {
    AddFrameShapeDialogVue,
    EditFrameShapeDialogVue,
  },
  data: () => {
    return {
      showAddDialog: false,
      showEditDialog: false,
      showDeleteDialog: false,
      editIndex: 0,
      deleteIndex: 0,
      deleteLoading: false,
      faceShapes: [] as FrameShapeInterface[],
    };
  },
  methods: {
    ...mapActions["showAlert"],
    getMediaRoute(filename?: string) {
      if (filename) {
        return `${configManager.getConfigAsString(
          "axios.apiHost"
        )}/images/${filename}`;
      } else {
        return require("@/assets/placeholder.png");
      }
    },
    prepareObjectDeletion(id: number) {
      this.deleteIndex = id;
      this.showDeleteDialog = true;
    },
    async deleteObject(id: number) {
      this.deleteLoading = true;
      try {
        await configuredAxios.request({
          url: `config/workflow/frameshape/${this.deleteIndex}`,
          method: "DELETE",
        });
        await this.refreshObjects();
      } catch (error) {
        this.showAlert({
          message: error.message,
          color: "warning",
          timeout: 3500,
        });
        console.error(error);
      }
      this.deleteIndex = 0;
      this.deleteLoading = false;
      this.showDeleteDialog = false;
    },
    async refreshObjects() {
      // TBD
      try {
        // TBD
        const faceShapes = (
          await configuredAxios.request({
            url: "/config/workflow/frameshape",
            method: "GET",
          })
        ).data;
        this.faceShapes = faceShapes;
      } catch (error) {
        this.showAlert({
          message: error.response ? error.response.data.message : error.message,
          color: "warning",
          timeout: 3500,
        });
        console.error(error);
      }
    },
    async afterCreatedObject() {
      this.showAddDialog = false;
      await this.refreshObjects();
    },
    async editObject(id: number) {
      this.editIndex = id;
      this.showEditDialog = true;
    },
    async afterEditedObject() {
      this.showEditDialog = false;
      this.editIndex = 0;
      await this.refreshObjects();
    },
  },

  async beforeMount() {
    await this.refreshObjects();
  },
});
